<template>
  <div class="app-container">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
      <div>
        <h1 style="margin: 0;">Zarządzaj sekcją "Zaufali nam"</h1>
        <span style="color: #909399; font-size: 13px;">Liczba wpisów: {{ list.length }}</span>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
        Dodaj nowy
      </el-button>
    </div>

    <el-table v-loading="loading" :data="list" border fit style="width: 100%">
      <el-table-column label="AVATAR" width="80" align="center">
        <template slot-scope="{ row }">
          <img
            :src="row.avatar_url"
            :alt="row.company_name"
            style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;"
          />
        </template>
      </el-table-column>

      <el-table-column label="URL PROFILU" min-width="250">
        <template slot-scope="{ row }">
          <a :href="row.profile_url" target="_blank" rel="noopener noreferrer" style="color: #409eff;">
            {{ row.profile_url }}
          </a>
        </template>
      </el-table-column>

      <el-table-column label="FIRMA" min-width="180">
        <template slot-scope="{ row }">
          {{ row.company_name || '—' }}
        </template>
      </el-table-column>

      <el-table-column label="AKCJE" width="120" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="mini"
            circle
            @click="openEditDialog(row)"
          ></el-button>
          <el-popconfirm
            confirm-button-text="Tak"
            cancel-button-text="Nie"
            icon="el-icon-info"
            icon-color="red"
            title="Czy na pewno chcesz usunąć ten wpis?"
            @confirm="handleDelete(row)"
          >
            <el-button
              slot="reference"
              type="danger"
              icon="el-icon-delete"
              size="mini"
              circle
            ></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- Add/Edit Dialog -->
    <el-dialog
      :title="editingItem ? 'Edytuj wpis' : 'Dodaj nowy wpis'"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-position="top">
        <el-form-item label="Firma">
          <el-input v-model="form.company_name" placeholder="np. TechCorp Poland"></el-input>
        </el-form-item>
        <el-form-item label="URL Avatara *">
          <el-input v-model="form.avatar_url" placeholder="https://example.com/avatar.jpg"></el-input>
        </el-form-item>
        <el-form-item label="URL Profilu *">
          <el-input v-model="form.profile_url" placeholder="https://linkedin.com/in/username"></el-input>
        </el-form-item>
        <div v-if="form.avatar_url && editingItem" style="margin-bottom: 10px;">
          <span style="font-size: 13px; color: #606266;">Podgląd:</span>
          <div style="margin-top: 8px;">
            <img
              :src="form.avatar_url"
              style="width: 64px; height: 64px; border-radius: 50%; object-fit: cover; border: 2px solid #409eff;"
            />
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">
          {{ editingItem ? 'Zapisz zmiany' : 'Dodaj' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TrustedCompanyResource from '@/api/trusted-companies';

const resource = new TrustedCompanyResource();

export default {
  name: 'TrustedCompanies',
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      dialogVisible: false,
      editingItem: null,
      form: {
        company_name: '',
        avatar_url: '',
        profile_url: '',
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        var res = await resource.list({});
        this.list = res.data || res;
      } catch (e) {
        this.$message.error('Nie udało się pobrać listy');
      }
      this.loading = false;
    },
    openAddDialog() {
      this.editingItem = null;
      this.form = { company_name: '', avatar_url: '', profile_url: '' };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.editingItem = row;
      this.form = {
        company_name: row.company_name || '',
        avatar_url: row.avatar_url,
        profile_url: row.profile_url,
      };
      this.dialogVisible = true;
    },
    async handleSave() {
      if (!this.form.avatar_url || !this.form.profile_url) {
        this.$message.warning('URL Avatara i URL Profilu są wymagane');
        return;
      }
      this.saving = true;
      try {
        if (this.editingItem) {
          await resource.update(this.editingItem.id, this.form);
          this.$message.success('Wpis zaktualizowany');
        } else {
          await resource.store(this.form);
          this.$message.success('Wpis dodany');
        }
        this.dialogVisible = false;
        this.getList();
      } catch (e) {
        var msg = (e.response && e.response.data && e.response.data.message) || 'Wystąpił błąd';
        this.$message.error(msg);
      }
      this.saving = false;
    },
    async handleDelete(row) {
      this.loading = true;
      try {
        await resource.destroy(row.id);
        this.list = this.list.filter(function(item) { return item.id !== row.id; });
        this.$message.success('Wpis usunięty');
      } catch (e) {
        this.$message.error('Nie udało się usunąć wpisu');
      }
      this.loading = false;
    },
  },
};
</script>
